<template>
  <div class="page article-detail-page flex-col">
    <AppHeader />
    
    <div class="content">
      <!-- <van-nav-bar title="文章详情" :fixed="true" left-arrow @click-left="$router.back()" :border="false" class="custom-nav" /> -->
      <div class="empty-state" v-if="!article.title && !loading">
        <p class="empty-state-text">暂无数据</p>
      </div>
      <template v-else>
        <h1 class="article-title">{{ article.title }}</h1>
        <div class="article-meta flex-row align-center"> 
          <span class="meta-item" v-if="article.publishTime || article.createTime || article.date">发表日期：{{ article.publishTime || article.createTime || article.date }}</span>
          <span class="meta-item" v-if="article.hit">浏览：{{ article.hit || 99 }}</span>  
        </div>
        <div class="article-meta flex-row align-center">  
          <span class="meta-item" v-if="article.source">来源：{{ article.source }}</span>
        </div>
        <Divider/>
        <div class="article-content" v-html="article.content || article.articleContent || mockContent"></div>
      </template>
    </div>
    <BackTop />
    <CopyrightFooter />
  </div>

</template>

<script>
import { NavBar,Divider  } from 'vant'
import { getContent } from '../api/content'
import CopyrightFooter from './components/CopyrightFooter.vue'
import BackTop from './components/BackTop.vue'
import AppHeader from './components/AppHeader.vue'

export default {
  components: {
    [NavBar.name]: NavBar,
    CopyrightFooter,
    BackTop,
    Divider,
    AppHeader
  },
  data() {
    return {
      article: {},
      loading: false,
      mockContent: '<p>为深入贯彻落实党中央、国务院关于生态文明建设的决策部署，进一步加强生态环境保护工作，推动绿色发展，促进人与自然和谐共生。</p><p>各地各部门要高度重视，切实加强组织领导，明确责任分工，确保各项工作落到实处。要坚持以习近平生态文明思想为指导，牢固树立绿水青山就是金山银山的理念，统筹推进山水林田湖草沙一体化保护和修复。</p><p>要加强生态环境监测网络建设，完善监测体系，提高监测能力，为生态环境决策提供科学依据。要加大环境执法力度，严厉打击各类环境违法行为，维护人民群众环境权益。</p>',
    }
  },
  mounted() {
    this.loadDetail() 
  },
  methods: {
    async loadDetail() {
      const id = this.$route.params.id
      this.loading = true
      try {
        const data = await getContent({ id })
        this.article = data && typeof data === 'object' ? data : this.mockArticle(id)
        document.title = this.article.title
        // 设置文章 SEO
        document.querySelector('meta[name="description"]').setAttribute('content', data.descrip || this.article.title)
        document.querySelector('meta[name="keywords"]').setAttribute('content', data.keyword || this.article.title)
      } catch (e) {
        console.error('获取文章详情失败：', e)
        this.article = this.mockArticle(id)
      } finally {
        this.loading = false
      }
    },
    mockArticle(id) {
      return {
        id,
        title: '中国环境与发展国际合作委员会2026年圆桌会在福建厦门召开',
        source: '生态环境部',
        publishTime: '2026-06-26',
        author: '张三',
      }
    },
  },
  destroyed() {
    // 恢复默认 SEO
    if (window.__appSeo) {
      document.querySelector('meta[name="description"]').setAttribute('content', window.__appSeo.description)
      document.querySelector('meta[name="keywords"]').setAttribute('content', window.__appSeo.keywords)
      document.title = window.__appSeo.title
    }
  },
}
</script>

<style scoped lang="scss">
.article-detail-page {
  background-color: #f5f5f5;
  min-height: 100vh;
}
.custom-nav {
  background-color: #0464CA;
  ::v-deep .van-nav-bar__title { color: #fff; font-weight: 600; }
  ::v-deep .van-nav-bar__arrow { color: #fff; }
}
.content {
  padding: 16px;
  background: #fff;
  margin:16px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
}
.article-title {
  font-size: 18px;
  font-weight: 700;
  color: #222;
  line-height: 1.5;
  margin: 0 0 12px;
}
.article-meta {
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.meta-item {
  font-size: 10px;
  color: #999;
}
.article-content { 
  line-height: 1.8;
  ::v-deep p {
    margin: 0 0 12px;
  }
  ::v-deep img {
    display: block;
    max-width: 100% !important;
    height: auto !important;
    margin: 16px auto;
    border-radius: 8px;
  }
  ::v-deep video{
    width: 100%;
  }
}
</style>
